import { RTABAK_URLS } from "../utils/urls";
import request from "./request";

const ManufacturingCostService = {
  getManufacturingCost: async (): Promise<any> =>
    request({
      baseURL: RTABAK_URLS.API.GetManufacturingCost,
      method: "GET",
      headers: {
        Accept: "aplication/json",
      },
    }).then((res) => {
      return res;
    }),
};

export { ManufacturingCostService };
